import { render, staticRenderFns } from "./flipchart.vue?vue&type=template&id=bb18260c&scoped=true&"
var script = {}
import style0 from "./flipchart.vue?vue&type=style&index=0&id=bb18260c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18260c",
  null
  
)

export default component.exports